import { Fragment } from "react";
import { motion } from "framer-motion";
import { MoveRight, MoveDown } from "lucide-react";

const DEFAULT_TAGS = ["Input", "Processing", "Output / Value"];

export const ProcessFlow = ({ steps, dark = false, testid, tags }) => (
    // eslint-disable-next-line
    <div
        data-testid={testid}
        className="flex flex-col gap-3 md:flex-row md:items-stretch md:gap-0"
    >
        {steps.map((s, i) => (
            <Fragment key={s.label}>
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{
                        duration: 0.8,
                        delay: i * 0.18,
                        ease: [0.16, 1, 0.3, 1],
                    }}
                    className={`flex-1 rounded-xl border p-6 transition-[border-color,transform] duration-400 hover:-translate-y-1 ${
                        dark
                            ? "border-white/10 bg-white/[0.04] hover:border-[#7CBF52]/50"
                            : "border-[#DCE5D4] bg-white hover:border-[#598B3B]/50"
                    }`}
                >
                    <div className="flex items-center justify-between">
                        <span
                            className={`text-[10px] font-bold uppercase tracking-[0.24em] ${
                                dark ? "text-[#7CBF52]" : "text-[#598B3B]"
                            }`}
                        >
                            {(tags || DEFAULT_TAGS)[i] || `Stage ${i + 1}`}
                        </span>
                        <span
                            className={`flex h-10 w-10 items-center justify-center rounded-lg ${
                                dark
                                    ? "bg-[#7CBF52]/10 text-[#7CBF52]"
                                    : "bg-[#598B3B]/10 text-[#598B3B]"
                            }`}
                        >
                            <s.icon size={19} strokeWidth={1.6} />
                        </span>
                    </div>
                    <p
                        className={`font-display mt-5 text-lg font-medium leading-snug tracking-tight ${
                            dark ? "text-[#F4F6F4]" : "text-[#0E1112]"
                        }`}
                    >
                        {s.label}
                    </p>
                    <p
                        className={`mt-2 text-[13px] leading-relaxed ${
                            dark ? "text-[#93A68E]" : "text-[#5C6B57]"
                        }`}
                    >
                        {s.sub}
                    </p>
                </motion.div>
                {i < steps.length - 1 && (
                    <div className="flex items-center justify-center md:px-3">
                        <MoveRight
                            size={20}
                            className="hidden text-[#598B3B] md:block"
                            strokeWidth={1.6}
                        />
                        <MoveDown
                            size={20}
                            className="text-[#598B3B] md:hidden"
                            strokeWidth={1.6}
                        />
                    </div>
                )}
            </Fragment>
        ))}
    </div>
);
